import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    // Connect to breadcrumb buttons (which are outside our scope in the DOM)
    this.submitButton = document.getElementById("breadcrumb-submit")
    this.aiButton = document.getElementById("breadcrumb-ai-generate")

    if (this.submitButton) {
      this.boundSubmit = this.submit.bind(this)
      this.submitButton.addEventListener("click", this.boundSubmit)
    }

    if (this.aiButton) {
      this.boundAiGenerate = this.triggerAiGenerate.bind(this)
      this.aiButton.addEventListener("click", this.boundAiGenerate)
    }
  }

  disconnect() {
    if (this.submitButton && this.boundSubmit) {
      this.submitButton.removeEventListener("click", this.boundSubmit)
    }
    if (this.aiButton && this.boundAiGenerate) {
      this.aiButton.removeEventListener("click", this.boundAiGenerate)
    }
  }

  submit(event) {
    // Find the form. Order of preference:
    //   1. The button's explicit `form="..."` attribute (so we submit the
    //      same form HTML5 would submit if JS weren't here).
    //   2. The Stimulus form target.
    //   3. Any form on the page tagged with data-form-actions-target="form".
    const explicitFormId = event.currentTarget.getAttribute("form")
    const form = (explicitFormId && document.getElementById(explicitFormId))
              || (this.hasFormTarget && this.formTarget)
              || document.querySelector('form[data-form-actions-target="form"]')

    if (!form) {
      console.warn("form-actions: no form found; falling back to native click")
      return // let the browser do whatever default it would do
    }

    // We found the form — submit via JS so we can suppress the native click
    // default (avoids a double-submit when the button is type=submit form=...).
    event.preventDefault()
    form.requestSubmit()
  }

  triggerAiGenerate(event) {
    event.preventDefault()

    const button = this.aiButton
    if (!button) return

    const spinner = button.querySelector("[data-ai-spinner]")
    const buttonText = button.querySelector("[data-ai-text]")

    // Find the ai-generate or book-lookup controller on the form and trigger it
    let aiController = this.application.getControllerForElementAndIdentifier(
      this.formTarget,
      "ai-generate"
    )
    let generateMethod = aiController ? "generate" : null

    if (!aiController) {
      aiController = this.application.getControllerForElementAndIdentifier(
        this.formTarget,
        "book-lookup"
      )
      generateMethod = aiController ? "aiGenerate" : null
    }

    if (aiController && generateMethod && typeof aiController[generateMethod] === "function") {
      // Show loading state
      button.disabled = true
      if (spinner) spinner.classList.remove("hidden")
      if (buttonText) buttonText.textContent = "Generating..."

      // Call generate
      aiController[generateMethod](event)

      // Watch for completion by monitoring the form's AI button
      const formButton = this.formTarget.querySelector("[data-ai-generate-target='button']") ||
        this.formTarget.querySelector("[data-book-lookup-target='aiButton']")
      if (formButton) {
        const checkCompletion = () => {
          if (!formButton.disabled) {
            button.disabled = false
            if (spinner) spinner.classList.add("hidden")
            if (buttonText) buttonText.textContent = "AI Generate"
          } else {
            setTimeout(checkCompletion, 200)
          }
        }
        setTimeout(checkCompletion, 200)
      } else {
        // Fallback: reset after 10 seconds
        setTimeout(() => {
          button.disabled = false
          if (spinner) spinner.classList.add("hidden")
          if (buttonText) buttonText.textContent = "AI Generate"
        }, 10000)
      }
    }
  }
}
